import EventRadioSelect from "./events-radio-select";

export default EventRadioSelect;